//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import numericclean from "@/components/numericClean";
import numericsimple from "@/components/numericSimple";
import lazyLoadSelect from "@/components/LazyLoadSelect";
import logger from "@/utils/logger";

import {
    mapState,
    mapActions
} from "vuex";
import {
    date
} from "quasar";

// import { getValue } from "vue-currency-input";
export default {
    props: {
        order: {},
        currencyCode: {},
        productCategoryLinks: {},
        supplierDiscounts: {},
    },
    components: {
        numericclean,
        numericsimple,
        lazyLoadSelect
    },

    data() {
        return {
            isInitializing: false,
            disableRecieveAllButton: false,
            showReceiving: false,
            showCreatelocation: false,
            confirmReceiveAll: false,
            dense: true,
            transactions: [],
            selectedLine: {},
            exchangeRate: null,
            exchangeRateCurrencyCodeId: null,
            Locations: [],
            Warehouses: [],
            Products: [],
            FilterWarehouses: [],
            FilterLocations: [],
            VatTypes: [],
            currency: "",
            warehouseName: "",
            locationName: "",
            locationGroupName: "",
            warehouseId: -1,
            FilterVatTypes: [],
            dimension1: {},
            dimension2: {},
            dimension3: {},
            dimension4: {},
            dimension5: {},
            dimension6: {},
            dimension7: {},
            dimension8: {},
            dimension9: {},
            disableRecieving: false,
            locationId: {},
            receiveQuantity: 0,
            pagination: {
                page: 1,
                rowsPerPage: 0, // 0 means all rows
            },

            visibleColumns: [
                "productId",
                "customerOrderRef",
                "itemText",
                "quantity",
                "productUnit",
                "received",
                "remaining",
                "price",
                "discountPercentage",
                "sum",
                "deliveryDate",
                "vatTypeId",
            ],
            columns: [{
                    name: "productId",
                    align: "left",
                    label: "Produkt",
                    field: "productId",
                    sortable: true,
                },
                {
                    name: "itemText",
                    align: "left",
                    label: "Beskrivelse",
                    field: "itemText",
                    sortable: true,
                    headerStyle: "min-width: 300px",
                    style: "min-width: 300px",
                },
                {
                    name: "quantity",
                    align: "right",
                    label: "Antall",
                    field: "numberOfItems",

                    sortable: true,
                },
                {
                    name: "productUnit",
                    align: "left",
                    label: "Enhet",
                    field: "productUnit",
                    sortable: true,
                },
                {
                    name: "supplierProductNumber",
                    align: "left",
                    label: "Lev.Produktnummer",
                    field: "supplierProductNumber",
                    sortable: true,
                },
                {
                    name: "received",
                    align: "right",
                    label: "Mottatt",
                    field: "received",
                    sortable: true,
                },
                {
                    name: "remaining",
                    align: "right",
                    label: "Rest",
                    field: "remaining",
                    sortable: true,
                },

                {
                    name: "price",
                    align: "right",
                    label: "Pris",
                    field: "price",
                    sortable: true,
                },

                {
                    name: "discountPercentage",
                    align: "right",
                    label: "Rabatt %",
                    field: "discountPercentage",
                    sortable: true,
                },
                {
                    name: "sum",
                    align: "right",
                    label: "Sum",
                    field: "sum",
                    sortable: true,
                },
               
                {
                    name: "deliveryDate",
                    align: "right",
                    label: "Lev.dato",
                    field: "deliveryDate",
                    format: (val) => date.formatDate(val, "DD-MM-YYYY"),
                    sortable: true,
                },
                {
                    name: "vatTypeId",
                    align: "left",
                    label: "MVA.kode",
                    field: "vatTypeId",
                    sortable: true,
                },
                {
                    name: "customerOrderRef",
                    align: "left",
                    label: "Kunde ordre",
                    field: "customerOrder",
                    format: (val) => this.customerOrderRef(val),
                    sortable: true,
                    style: "width: 35px",
                },
            ],
            receivedProducts: [{
                    name: "id",
                    align: "left",
                    label: "Id",
                    field: "id",
                    sortable: true,
                },

                {
                    name: "locationName",
                    align: "left",
                    label: "Lokasjonsnavn",
                    field: "locationName",
                    sortable: true,
                },
                {
                    name: "numberOfItems",
                    align: "left",
                    label: "Mottatt",
                    field: "numberOfItems",
                    sortable: true,
                },

            ],
        };
    },

    computed: {
        ...mapState("main", [
            "warehouses",
            "locations",
            "suppliers",
            "vatTypes",
            "dimensions",
            "currencies",
        ]),

        isRecevingMode() {
            return this.$route.name === "PurchaseReceive";
        },
    },
    watch: {
        warehouseId(newWarehouseId, oldwarehouseId) {
            if (this.isInitializing)
                return;

            if (oldwarehouseId === -1)
                return;

            if(newWarehouseId === oldwarehouseId)
                return;

            this.updateLocations(newWarehouseId);
        },
    },
    methods: {
        ...mapActions("main", [
            "postPurchaseOrderItemTransaction",
            "postPurchaseOrderItemTransactionsBatch",
            "getProject",
            "getLocation",
            "postLocation",
            "deletePurchaseOrderItemTransaction",
            "getExchangeRate",
            'getReferencesSupplierProducts',
            'getProduct'
        ]),

        async fetchProducts({ pageNumber, pageSize, searchQuery }) {
            var supplierId = this.order.supplierId;
            if (!supplierId) {   
                this.$q.notify({
                    type: "warning",
                    message: "Begynn med å legge til leverandøren.",
                });
                return { items: [], totalPages: 1 }
            }

            try {
                const result = await this.getReferencesSupplierProducts({
                    supplierId,
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'ProductNumber',
                    sortDescending: false
                })
                return result
            } catch (error) {
                console.error('Error fetching products:', error)
                return { items: [], totalPages: 1 }
            }
        },

        async fetchProduct(productId) {
            try {
                const result = await this.getProduct(productId)
                return result;
            } catch (error) {
                console.error('Error fetching product:', error)
                return null;
            }
        },

        productLabel(product) {
            if (!product) return ''
            return `${product.productNumber}: ${product.productName}`
        },

        customerOrderRef(customerOrder) {           

            if (customerOrder) {                
                return '<div class="tooltip"><a href="/#/Orders/' + customerOrder.id + '"><img src="/icons/pick.svg" style="height: 31px; font-size: 1.715em" /></a><span class="tooltiptext">' + customerOrder.orderNumber + '</span></div>';                
            }

            return '';
        },

        addRowImproved() {
            const row = {
                productId: null,
                productNumber: null,
                numberOfItems: 1,
                discountPercentage: 0,
                price: 0,
                sum: 0,
                dimension1Id: this.order.dimension1Id,
                dimension2Id: this.order.dimension2Id,
                dimension3Id: this.order.dimension3Id,
                dimension4Id: this.order.dimension4Id,
                dimension5Id: this.order.dimension5Id,
                dimension6Id: this.order.dimension6Id,
                dimension7Id: this.order.dimension7Id,
                dimension8Id: this.order.dimension8Id,
                dimension9Id: this.order.dimension9Id,
            };
            this.order.orderItems.push(row);
            this.$emit("rowAdded");

        },

        async createLocation() {
            this.isInitializing = true;
            var object = {};
            try {
                if (!this.locationName) {
                    this.$q.notify({
                        type: "warning",
                        message: "Vennligst oppgi et navn på lokasjonen.",
                    });
                    return;
                }

                object["locationName"] = this.locationName;
                object["locationGroupName"] = this.locationGroupName;
                object["isDeleted"] = false;
                object["warehouseId"] = this.warehouseId;

                var res = await this.postLocation(object);

                this.$q.notify({
                    type: "positive",
                    message: this.$t("common.saveOk"),
                });
                await this.getLocation();
                this.Locations = this.locations;
                this.FilterLocations = this.locations;
                this.newWarehouseId = res.warehouseId;
                this.locationId = res.id;

                this.showCreatelocation = false;
            } catch (error) {
                logger.log("error", error);
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`,
                });
            } finally {
                this.$nextTick(() => {
                    this.isInitializing = false;
                });
            }
        },

        calculateRow(row) {
            if (row) {
                if (row.productId) {
                    var price = row.price;

                    const qtySum = row.numberOfItems * price;
                    // const vat = this.VatTypes.find((k) => k.id === row.vatTypeId);
                    const discount = (qtySum * row.discountPercentage) / 100;
                    const total = qtySum - discount;
                    row.sum = new Intl.NumberFormat("no-NO").format(total);
                }
                this.$emit("rowModified");
            }
        },

        addDimensionColumns() {
            this.dimensions.sort((a, b) => {
                return a.dimension.localeCompare(b.dimension);
            });
            this.dimensions.forEach((d) => {
                var d2 = JSON.parse(JSON.stringify(d));
                d2.dimensions.splice(0, 0, {
                    number: null,
                    id: null,
                    name: ""
                });
                if (d.dimension === "1") this.dimension1 = d2;
                if (d.dimension === "2") this.dimension2 = d2;
                if (d.dimension === "3") this.dimension3 = d2;
                if (d.dimension === "4") this.dimension4 = d2;
                if (d.dimension === "5") this.dimension5 = d2;
                if (d.dimension === "6") this.dimension6 = d2;
                if (d.dimension === "7") this.dimension7 = d2;
                if (d.dimension === "8") this.dimension8 = d2;
                if (d.dimension === "9") this.dimension9 = d2;

                var dimensionId = "dimension" + d.dimension + "Id";
                this.columns.push({
                    name: dimensionId,
                    align: "left",
                    label: d.label,
                    field: dimensionId,
                    sortable: true,
                });
            });
        },

        getVatTypesFilter(val, update) {
            if (!this.VatTypes) {
                update();
                return;
            }

            update(
                () => {
                    this.VatTypes = this.FilterVatTypes.filter(
                        (v) =>
                        (v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
                            v.vatCode.toLowerCase().indexOf(val.toLowerCase()) > -1) &&
                        v.visible &&
                        !v.deleted &&
                        (v.vatCodeGroupID == 11 || v.vatCodeGroupID == 13)
                    );
                },
                (ref) => {
                    ref.setOptionIndex(-1);
                    ref.moveOptionSelection(1, true);
                }
            );
        },
        async initSelectBox() {
            this.VatTypes = this.vatTypes;
            if (!this.VatTypes) {
                this.VatTypes = await this.getVatType();
            }
            this.FilterVatTypes = this.VatTypes;
        },

        resetProductRow(row) {
            row.productId = null
            row.productNumber = null
            row.numberOfItems = 1
            row.discountPercentage = 0
            row.price = 0
            row.sum = 0
            row.supplierProductNumber = null
            row.vatTypeId = null
        },

        async productValueChanged(row, productId) {
            if (row.isLoading) {
                return;
            }

            this.resetProductRow(row);

            if (!productId) {
                return;
            }

            row.isLoading = true;
            
            try {
                const product = await this.getProduct(productId);
                if (!product) {
                    return;
                }

                row.dirty = 1
                row.productId = product.id
                row.productNumber = product.productNumber
                row.itemText = product.productName
                row.productUnit = product.unit

                var supplierProduct = null;
                var supplierId = this.order.supplierId;

                if (Array.isArray(product.supplierProduct) && product.supplierProduct.length > 0) {    
                    supplierProduct = product.supplierProduct.find(supplier => supplier.supplierId === supplierId);
                    
                    if (supplierProduct === undefined) { 
                        supplierProduct  = product.supplierProduct.reduce((lowest, current) => {        
                            const currentPriority = current.priority ?? Number.MAX_SAFE_INTEGER;
                            const lowestPriority = lowest.priority ?? Number.MAX_SAFE_INTEGER;
                            return currentPriority < lowestPriority ? current : lowest;
                        }, product.supplierProduct[0]);
                    }               
                } 

                if (supplierProduct && supplierProduct.supplierProductNumber)
                {                
                    row.supplierProductNumber = supplierProduct.supplierProductNumber;                
                }

                if (supplierProduct && supplierProduct.price && supplierProduct.currencyCodeId == this.order.currencyCodeId)
                {
                    row.price = supplierProduct.price;     
                }
                else if (product.costPrice) {
                    if (this.order.currencyCodeId != 1) {
                        if (
                            !this.exchangeRate ||
                            this.exchangeRateCurrencyCodeId != this.order.currencyCodeId
                        ) {
                            this.exchangeRateCurrencyCodeId = this.order.currencyCodeId;
                            this.exchangeRate = (
                                await this.getExchangeRate(this.order.currencyCodeId)
                            ).exchangeRate;
                        }
                        var currencyPrice = product.costPrice / this.exchangeRate;
                        row.price = currencyPrice;
                    } else {
                        row.price = product.costPrice;
                    }
                }

                if (supplierProduct && supplierProduct.incomingVatTypeId)
                    row.vatTypeId = supplierProduct.incomingVatTypeId;

                if (
                    (row.discountPercentage == null || row.discountPercentage == 0) &&
                    this.order.supplierId > 0 &&
                    row.productId > 0
                ) {
                    var productlinks = this.productCategoryLinks.filter(
                        (x) => x.productID == row.productId
                    );
                    if (productlinks.length > 0) {
                        var discounts = this.supplierDiscounts.filter(
                            (x) =>
                            x.supplierId == this.order.supplierId &&
                            productlinks.filter(
                                (y) => y.productCategoryID == x.productCategoryId
                            )
                        );
                        if (discounts.length > 1) {
                            discounts.sort((a, b) => {
                                return b.discount - a.discount;
                            });
                        }
                        if (discounts.length > 0) {
                            row.discountPercentage = discounts[0].discount;
                        }
                    }
                }

                // this.calculateSum();
                this.calculateRow(row);
            } finally {
                row.isLoading = false;
            }
        },

        vatValueChanged(row, vat) {
            row.vatTypeId = vat.id;
        },

        async deliveryDateChanged(row) {
            row.deliveryDate = this.autoCompleteDate(row.deliveryDate);
        },

        autoCompleteDate(strDate) {
            if (strDate.length > 0 && strDate.length < 7) {
                if (isNaN(parseInt(strDate))) return "";
                try {
                    if (strDate.length < 6) {
                        let today = new Date();
                        if (strDate.length == 1)
                            strDate = "0" + strDate + date.formatDate(today, "MMYY");
                        else if (strDate.length == 2)
                            strDate = strDate + date.formatDate(today, "MMYY");
                        else if (strDate.length == 3) {
                            strDate = strDate.substring(0, 2) + "0" + strDate.substring(2, 3);
                            strDate = strDate + date.formatDate(today, "YY");
                        } else if (strDate.length == 4)
                            strDate = strDate + date.formatDate(today, "YY");
                        else if (strDate.length == 5) {
                            strDate = strDate.substring(0, 4);
                            strDate = strDate + date.formatDate(today, "YY");
                        }
                    }

                    let newDate = date.extractDate(strDate, "DDMMYY");
                    return date.formatDate(newDate, "DD-MM-YYYY");
                } catch (error) {
                    return "";
                }
            }
            return strDate;
        },

        dimension1ValueChanged(row, dimension) {
            row.dimension1Id = dimension.id;
        },
        dimension2ValueChanged(row, dimension) {
            row.dimension2Id = dimension.id;
        },
        dimension3ValueChanged(row, dimension) {
            row.dimension3Id = dimension.id;
        },
        dimension4ValueChanged(row, dimension) {
            row.dimension4Id = dimension.id;
        },
        dimension5ValueChanged(row, dimension) {
            row.dimension5Id = dimension.id;
        },
        dimension6ValueChanged(row, dimension) {
            row.dimension6Id = dimension.id;
        },
        dimension7ValueChanged(row, dimension) {
            row.dimension7Id = dimension.id;
        },
        dimension8ValueChanged(row, dimension) {
            row.dimension8Id = dimension.id;
        },
        dimension9ValueChanged(row, dimension) {
            row.dimension9Id = dimension.id;
        },
        async updateLocations(warehouseId) {   
            logger.log("Filter by id: " + warehouseId)   
            this.locationId = null;
            this.filterLocationsForWarehouse(warehouseId);
            let selectedLocationId = null;

            if (this.selectedLine.stock?.length > 0) {
                let recommendedStocksArray = this.selectedLine.stock
                .filter(stock => stock.quantity > 0 && stock.warehouseId === warehouseId)
                .sort((a, b) => {
                    if (b.quantity !== a.quantity) {
                        return b.quantity - a.quantity; 
                    }
                    if (a.created && b.created) {
                        return new Date(b.created) - new Date(a.created); 
                    }
                    return 0;
                });

                if (recommendedStocksArray.length > 0) {
                    selectedLocationId = recommendedStocksArray[0].locationId;
                    logger.log("Using stock-based location:", selectedLocationId);
                }
            }
            
            if (!selectedLocationId) {
                selectedLocationId = this.getDefaultLocation();
                logger.log("Using default location:", selectedLocationId);
            }

            await this.$nextTick();
            this.locationId = selectedLocationId;
        },
        getLocationsFilter(val, update) {
            if (!this.locations) {
                update();
                return;
            }
            update(() => {
                const needle = val.toLowerCase();
                this.Locations = this.locations.filter(
                    (l) =>
                    l.warehouseId === this.warehouseId &&
                    l.locationName.toLowerCase().indexOf(needle) > -1
                );
            });
        },
        // async getProjects() {
        //   this.Projects = await this.getProjects();
        //   this.FilterProjects = this.Projects;
        // },

        getWarehouseFilter(val, update) {
            if (!this.Warehouses) {
                update();
                return;
            }
            update(() => {
                this.Warehouses = this.FilterWarehouses.filter(
                    (w) =>
                    !w.isDeleted &&
                    w.warehouseName.toLowerCase().indexOf(val.toLowerCase()) > -1
                );
            });
        },

        async saveRecieving() {
            if (this.selectedLine.stockControlled && this.locationId <= 0) {
                return;
            }

            this.disableRecieving = true;

            var postTransaction = {
                purchaseOrderItemId: this.selectedLine.id,
                locationId: this.selectedLine.stockControlled ? this.locationId : -1,
                numberOfItems: this.receiveQuantity
            };

            const notif = this.$q.notify({
                type: 'ongoing',
                message: `Mottar ${this.receiveQuantity} ${this.selectedLine.productUnit || 'stk'}...`,
                timeout: 0,
                spinner: true
            });

            try {
                const createdDto = await this.postPurchaseOrderItemTransaction(postTransaction);
                if (!createdDto) {
                    notif({
                        type: 'negative',
                        message: this.$t("common.errorSave"),
                        timeout: 3000,
                        spinner: false
                    });
                } else {
                    await this.$parent.refresh();
                    this.resetForm();

                    notif({
                        type: 'positive',
                        message: this.$t("common.saveOk"),
                        timeout: 2000,
                        spinner: false
                    });
                }
            } catch (err) {
                notif({
                    type: 'negative',
                    message: `${this.$t("common.errorSave")}. ${this.$utils.GetErrorMessage(err)}`,
                    timeout: 3000,
                    spinner: false
                });
            } finally {
                this.disableRecieving = false;
            }
        },

        async receiveAll() {
            try {
                this.disableRecieveAllButton = true;
                const notReceivedItems = this.order.orderItems.filter(i => i.remaining > 0);
                
                if (notReceivedItems.length === 0) {
                    this.$q.notify({
                        type: "info",
                        message: "Ingen gjenstående varer å motta",
                    });
                    return;
                }

                const transactions = notReceivedItems
                    .filter(orderItem => {
                        if (orderItem.stockControlled && (!this.locationId || this.locationId <= 0)) {
                            return false;
                        }
                        return true;
                    })
                    .map(orderItem => ({
                        purchaseOrderItemId: orderItem.id,
                        locationId: orderItem.stockControlled ? this.locationId : -1,
                        numberOfItems: orderItem.remaining
                    }));

                if (transactions.length === 0) {
                    this.$q.notify({
                        type: 'warning',
                        message: 'Velg lokasjon for å motta lagerførte varer',
                        timeout: 3000,
                    });
                    return;
                }

                const notif = this.$q.notify({
                    type: 'ongoing',
                    message: `Mottar ${transactions.length} varelinjer...`,
                    timeout: 0,
                    spinner: true
                });

                var transactionIds = await this.postPurchaseOrderItemTransactionsBatch(transactions);
                
                if (!transactionIds || transactionIds.length === 0) {
                    notif({
                        type: 'negative',
                        message: this.$t("common.errorSave"),
                        timeout: 3000,
                        spinner: false
                    });
                } else {
                    this.resetForm();
                    await this.$parent.refresh();
                    
                    notif({
                        type: 'positive',
                        message: `${transactionIds.length} varelinjer mottatt!`,
                        timeout: 3000,
                        spinner: false
                    });
                }
            } catch (err) {
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t("common.errorSave")}. ${this.$utils.GetErrorMessage(err)}`,
                });
            } finally {
                this.disableRecieveAllButton = false;
            }
        },

        resetForm() {
            this.warehouseId = -1;
            this.locationId = -1;
            this.receiveQuantity = 0;
            this.showReceiving = false;
        },

        async deleteval(row) {
            var res = await this.deletePurchaseOrderItemTransaction(row.id);
            if (res == "true") {
                var index = this.transactions.indexOf(row);
                this.transactions.splice(index, 1);
            } else {
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorSave"),
                });
            }
        },

        deleteLine(index) {
            this.order.orderItems.splice(index, 1);
        },

        completeLine(row) {
            if (row.received == 0) {
                this.deleteLine(this.order.orderItems.indexOf(row))
            } else {
                row.numberOfItems = row.received;
            }

        },

        filterLocationsForWarehouse(warehouseId) {
            if (warehouseId > 0) {
                this.Locations = this.locations.filter(l => l.warehouseId === warehouseId);
                logger.log("Filtered locations for warehouse:", warehouseId, "Count:", this.Locations.length);
            } else {
                this.Locations = this.locations;
            }
        },

        onRowClick(row) {
            this.isInitializing = true;
            this.resetForm();
            this.selectedLine = row;
            this.transactions = row.transactions;

            var defaultWarehouse = this.Warehouses.filter(x => x.streetName == this.order.deliveryAddressLine1).sort((a, b) => {
                if (a.priority == null && b.priority == null) return 0;
                if (a.priority == null) return 1;
                if (b.priority == null) return -1; 
                return a.priority - b.priority; 
            })[0]; // first warehouse based on priority

            if(defaultWarehouse != undefined) { // default warehosue exist
                this.warehouseId = defaultWarehouse.id;
                this.filterLocationsForWarehouse(this.warehouseId);

                if(this.selectedLine.stock?.length > 0) { // check for default warehouse recommended stock
                    let warehouseLocations = this.Locations;
                    let warehouseLocationIds = warehouseLocations.map(loc => loc.id);
                    let firstStock = this.findSuitableDefaultStockFromStockList(this.selectedLine.stock, warehouseLocationIds);

                    if(firstStock == undefined || firstStock == null) {
                        this.locationId = this.getDefaultLocation();
                    }
                    else {
                        this.locationId = firstStock.locationId                    
                    }
                }
                else {
                    this.locationId = this.getDefaultLocation();
                }
            }
            else if(this.selectedLine.stock?.length > 0) { // no default warehouse - check for product's recommended stock

                let warehouseLocations = this.Locations;
                let warehouseLocationIds = warehouseLocations.map(loc => loc.id);
                let firstStock = this.findSuitableDefaultStockFromStockList(this.selectedLine.stock, warehouseLocationIds);

                if(firstStock == undefined || firstStock == null)
                    firstStock = this.selectedLine.stock[0];

                this.warehouseId = firstStock.warehouseId;
                this.filterLocationsForWarehouse(this.warehouseId);
                this.locationId = firstStock.locationId;
            }
            else if(this.Warehouses.length > 0) { // default to first warehouse and location.
                this.warehouseId = this.Warehouses[0].id;
                this.filterLocationsForWarehouse(this.warehouseId);
                
                this.locationId = this.getDefaultLocation();
            }
            
            this.receiveQuantity = row.remaining;            
            this.showReceiving = true;

            this.$nextTick(() => {
                this.isInitializing = false;
            });
        },
        findSuitableDefaultStockFromStockList(selectedLineStock, warehouseLocationIds) {
            if (!selectedLineStock?.length || !warehouseLocationIds?.length)
                return null;

            const warehouseStocks = [...selectedLineStock]
                .filter(stock => warehouseLocationIds.includes(stock.locationId))
                .sort((a, b) => {
                    if (a.created && b.created) {
                        return new Date(b.created) - new Date(a.created);
                    }
                    return 0;
                });

            const stockWithQuantity = warehouseStocks.find(stock => stock.quantity > 0);
            if (stockWithQuantity) {
                return stockWithQuantity;
            }

            return warehouseStocks[0] || null;
        },
        getDefaultLocation() {
            if (this.warehouseId <= 0)
                return null;

            const warehouseLocations = this.Locations.filter(l => l.warehouseId === this.warehouseId);
            if (warehouseLocations.length === 0)
                return null;

            return warehouseLocations[0].id;
        },
        onVisibleColumnsChange() {
            if (this.isRecevingMode)
                this.$cookies.set(
                    "purchaseOrderReceiveItemColumns",
                    this.visibleColumns.join(","),
                    "1Y"
                );
            else
                this.$cookies.set(
                    "purchaseOrderItemColumns",
                    this.visibleColumns.join(","),
                    "1Y"
                );
        },

        initVisibleColumns() {
            var cookieColums = this.$cookies.get("purchaseOrderItemColumns");
            if (this.isRecevingMode)
                cookieColums = this.$cookies.get("purchaseOrderReceiveItemColumns");

            if (cookieColums) {
                var columns = [];
                cookieColums.split(",").forEach(function (col) {
                    columns.push(col);
                });
                this.visibleColumns = columns;
            }
        },
    },
    created() {
        this.Locations = this.locations;
        this.FilterLocations = this.locations;
        this.FilterWarehouses = this.warehouses;
        this.Warehouses = this.warehouses;

        this.initSelectBox();
        this.addDimensionColumns();
        this.initVisibleColumns();
    },
    beforeUpdate() {},
};
